import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);

  const [countries, setCountries] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetAllCategory = async () => {
    const response = await getData("/all-banner-name");

    if (response?.success) {
      setCountries(await Select2Data(response?.data, "banner_name_id"));
    }
  };

  useEffect(() => {
    GetAllCategory();
  }, []);

  const [countLang, setCountLang] = useState([]);

  const {
    control,
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
    watch,
    clearErrors,
  } = useForm({
    defaultValues: {
      languages: [],
    },
  });

  const { fields } = useFieldArray({
    control,
    name: "languages",
  });

  const getLanguges = async () => {
    const response = await getData("/all-languages");
    setCountLang(response.data);

    reset({
      languages: response.data.map((lang) => ({
        language_id: lang.id,
        name: "",
      })),
    });
  };

  useEffect(() => {
    getLanguges();
  }, []);

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      // DataToSend.append("banner_name_id", data?.banner_name_id?.value);
      DataToSend.append("name", data.languages[0]?.name);
      DataToSend.append("languages", JSON.stringify(data.languages));
      // DataToSend.append("short_description", data?.short_description);
      DataToSend.append("video", data?.video[0]);
      const response = await postData(`/masters/traning-video`, DataToSend);
      console.log(response);
      console.log(DataToSend);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };
  const [videoPreview, setVideoPreview] = useState(null);

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setVideoPreview(URL.createObjectURL(file));
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Traning Video
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
            // className="stateclass"
          >
            <Row className="justify-content-center">
              {fields.map((field, index) => (
                <Col md={12} key={field.id}>
                  <div className="main-form-section mt-5">
                    <Row className="justify-content-center">
                      <Form.Label column sm={3}>
                        Name ({countLang[index]?.name})
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control
                              type="text"
                              placeholder={`Enter Name in ${countLang[index]?.name}`}
                              className="input-mandatory"
                              {...register(`languages.${index}.name`, {
                                required: `Name is required in ${countLang[index]?.name}`,
                              })}
                            />
                          </InputGroup>
                          {errors.languages?.[index]?.name && (
                            <span className="text-danger">
                              {errors.languages[index].name.message}
                            </span>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ))}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div>
                      <Form.Label>Video</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="file"
                        name="video"
                        placeholder="Video"
                        className={classNames("", {
                          "is-invalid": errors?.video,
                        })}
                        {...register("video", {
                          required: "Video is required",
                        })}
                        accept="video/*"
                        onChange={handleVideoChange} // change this function accordingly
                      />
                    </InputGroup>
                    {errors.video && (
                      <span className="text-danger">
                        {errors.video.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  {videoPreview && (
                    <div className="mt-2">
                      <video
                        src={videoPreview}
                        controls
                        style={{ maxWidth: "150px" }}
                      />
                    </div>
                  )}
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
